import React, { useEffect, useState } from 'react';
import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles';
import Jumbotron from '@shorelight/ui-common-components/cjs/components/containers/Jumbotron';
import Link from '@material-ui/core/Link';
import { connect } from 'react-redux';

import LoadingIndicator from '../LoadingIndicator/LoadingIndicator';
import { getSchema } from '../../utils/FormsClient';
import { ApplicationState } from '../../store/types';

const styles = () => ({
  confirmationContainer: {
    marginTop: 70
  },
  confirmationMessage: {
    fontSize: 25
  },
  printPageElement: {
    cursor: 'pointer',
    fontSize: 'inherit',
    textDecoration: 'underline',
    color: 'white'
  }
});

interface SuccessPageProps extends WithStyles<typeof styles> {
  successFormParams?: FormParams;
  confirmationNumber?: number;
}

export const SuccessPage = ({
  successFormParams,
  confirmationNumber,
  classes
}: SuccessPageProps) => {
  const [isLoading, setIsLoading] = useState(true);
  const [successContent, setSuccessContent] = useState(
    null as BasicPageContent | null
  );

  useEffect(() => {
    if (!successContent && successFormParams) {
      getSchema(successFormParams).then(content => {
        setSuccessContent(content);
        setIsLoading(false);
      });
    }
  }, [successContent, successFormParams]);

  if (!successContent || isLoading) {
    return <LoadingIndicator />;
  }

  const content = (
    <div>
      <p>{successContent.content}</p>
      {confirmationNumber && (
        <section className={classes.confirmationContainer}>
          <p className={classes.confirmationMessage}>
            Your confirmation # is <strong>{confirmationNumber}</strong>
          </p>
          <p>
            <Link
              component="button"
              variant="body2"
              className={classes.printPageElement}
              onClick={window.print}
            >
              Please print this page
            </Link>
            &nbsp;for your records.
          </p>
          <p>
            <strong>Have questions?</strong> Contact your recruiter anytime.
          </p>
        </section>
      )}
    </div>
  );

  return (
    <div data-testid={'success-title-content'}>
      <Jumbotron title={successContent.title} content={content} />
    </div>
  );
};

const mapStateToProps = (state: ApplicationState) => {
  const schema = state.wizard.schema;

  return {
    successFormParams: schema && schema.successPageParams
  };
};

const StyledSuccessPage = withStyles(styles)(SuccessPage);
export default connect(mapStateToProps)(StyledSuccessPage);
